module.exports = __webpack_public_path__ + "static/media/blog_2.822d50e1.jpg";